import { AssetDto, GalleryDto, GuestUserDto, MemberRole, TenantDto, UserDto } from '@picflow/types';

import { Injectable } from '@angular/core';
import { StripeCustomerDto } from '@picflow/types/billing/customer.dto';
import { Card } from '@stripe/stripe-js';
import { AuthToken } from '../classes/authToken';
import { FileConversion } from '../tools/convert/components/convert/convert.component';
import { Plan } from '../types/plan.type';

@Injectable({
  providedIn: 'root',
})
export class StateService {
  public lastReloadTime = Date.now();
  public user: UserDto;
  public stripeCustomerId: string;
  public balance: number;
  public guest: GuestUserDto;
  public tenants: TenantDto[];
  public activeTenant: TenantDto;
  public visitingTenantId: string; // gallery members
  public activeTenantRole: MemberRole;
  public activeTenantPermissions: string[];
  public guestAuthToken: string;
  public customAuthToken: string; // what?
  public preGuestAnonymousId: string;
  public darkMode: boolean;
  public sorting = '-last_changed_at';
  public appearance = 'default';
  public currentAsset: AssetDto;
  public emailVerified: boolean;
  public nextPageIsNotFound: boolean;
  public tokenData: AuthToken;
  public shareLinkCode: string;
  public plan: Plan;
  public stripeCustomer: StripeCustomerDto;
  public card: Card;
  public paymentMethod: string;
  public cardCreatedAt: number;
  public cardExpired: boolean;
  public cardExpiringSoon: boolean;
  public printOverview: {
    gallery: GalleryDto;
    assets: AssetDto[];
    favorites: boolean;
    flags: boolean;
    color_labels: boolean;
    filename: boolean;
    thumbnailSize: 'small' | 'medium' | 'large';
  };
  public filteredAssets: AssetDto[];
  public unseenActivity = 0;
  public unseenActivityCountMap: Map<string, number> = new Map();
  public activeFilterString: string;
  public activeFilterIncludesYourFavorites: boolean;
  public advancedModeFilteredAssets: AssetDto[];
  public advancedModeSelectedAssets: AssetDto[];
  public sentryTransaction: { traceId: string; spanId: string };
  public isPublic: boolean;
  public recordDebug = false;
  public debugResponseCache: unknown[] = [];
  public pathHistory: string[] = [];
  public renewAuthToken = async () => console.error('Auth service not loaded');
  public renewGuestAuthToken = async () => console.error('Guest-auth service not loaded');
  public removeAllGalleryPasswords = () => console.info('gallery password service not loaded');
  public extensionTabId: number;
  public temporarilyHideUpgradeCta = false;
  public videoSettings: { volume: number; speed: number; timeMode: 'seconds' | 'frames' } = {
    volume: 1,
    speed: 1,
    timeMode: 'seconds',
  };
  public conversionCache: FileConversion[] = [];
  public serverTimingData: {
    rows: { type: string; id: string; description: string; timeTaken: number }[];
    totalTimeTaken: number;
    url: string;
    method: string;
    requestBody: string;
    responseTime: number;
  }[] = [];
}
